import React, { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../../../config/config";
import { Space, Select } from "antd";

const { Option } = Select;

export default function SearchAutocomplete(props) {
  const { onValidate, entity, defaultValue, style, name, handleChange, value, placeholder, excludeBills } =
    props;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const keyUpHandler = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleOnEnter();
      }
    };
    // Every time the user presses and releases a key
    document.addEventListener("keyup", keyUpHandler);
    return () => {
      document.removeEventListener("keyup", keyUpHandler);
    };
  });

  const handleOnEnter = () => {
    if (value?.length === 0) {
      onValidate(null);
    } else {
      if (options[0]) {
        handleChange(options[0].label);
        onValidate(options[0]);
      }
    }
  };

  const fetchUserAutocomplete = (searchValue) => {
    axios
      .post(
        `${BACKEND_URL}/api/user/search`,
        {
          search: searchValue,
          includeBills: !excludeBills,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        formatAndSetResults(res.data);
      })
      .catch((error) => {
        console.error("error", error);
      });
  };

  const formatLabel = (el) => {
    switch(el.type) {
      case 'company': return `[Adhérent] ${el.label}`;
      case 'siren': return `[SIREN] ${el.label}`;
      case 'user': return `[Email] ${el.label}`;
      case 'bill': return `[Facture] ${el.label}`;
      case 'creditNote': return `[Avoir] ${el.label}`;
      case 'attestation': return `[Attestation] ${el.label}`;
      default: return el.label;
    }
  };

  const formatAndSetResults = (result) => {
    // nextOptions : results list about search
    const nextOptions = result.map((el, index) => {
      return {
        value: el.id,
        label: el.label, // Label brut pour l'input
        displayLabel: formatLabel(el), // Label avec préfixe pour le dropdown
        type: el.type,
        key: index,
      };
    });
    setOptions(nextOptions);
  };

  // we use this function to display the right value inside the text input when we click on an option.
  const handleSelect = (selectedValue) => {
    const element = options.find((option) => option.value === selectedValue);
    if (element) {
      handleChange(element.label);
      onValidate(element);
    }
  };

  const handleSearch = (searchValue) => {
    if (searchValue?.toString()?.length > 0) {
      switch (entity) {
        case "user":
          fetchUserAutocomplete(searchValue);
          break;
        default:
          break;
      }
    } else {
      setOptions([]);
      onValidate(null);
    }
  };

  return (
    <Space wrap>
      <Select
        showSearch
        filterOption={false}
        placeholder={placeholder || "Chercher une entreprise"}
        name={name}
        defaultValue={defaultValue ? defaultValue : undefined}
        value={value || undefined}
        onSearch={handleSearch}
        onSelect={handleSelect}
        onChange={handleChange}
        style={style}
        optionLabelProp="label"
        notFoundContent={null}
        allowClear
      >
        {options.map((opt) => (
          <Option key={opt.key} value={opt.value} label={opt.label}>
            {opt.displayLabel}
          </Option>
        ))}
      </Select>
    </Space>
  );
}
